// extracted by mini-css-extract-plugin
var _1 = "burger__tkPGj";
var _2 = "burger-inner__Tfa9k";
var _3 = "connectivity__wr6LA";
var _4 = "head-button-holder__yFYvW";
var _5 = "header__i_wgQ";
var _6 = "job-appendix__EFJIn";
var _7 = "save-enable__MK1m0";
var _8 = "sync__zgg7D";
var _9 = "title__h56gq";
var _a = "top-title__VECx1";
export { _1 as "burger", _2 as "burger-inner", _3 as "connectivity", _4 as "head-button-holder", _5 as "header", _6 as "job-appendix", _7 as "save-enable", _8 as "sync", _9 as "title", _a as "top-title" }
